import React, { useState } from 'react'

import { cloneDeep } from 'lodash/lang'

const withState = WrappedComponent => {
  return props => {
    const {
      setPickupPersonForm // via redux actions
    } = props

    const [formLoading, setFormLoading] = useState(true)

    const initialFormValues = {
      firstName: '',
      lastName: '',
      relationshipToCampers: '',
      legalGuardian: '',
      primaryPhone: '',
      alternatePhone: ''
    }

    if (formLoading) {
      setPickupPersonForm(cloneDeep(initialFormValues))
      setFormLoading(false)
    }

    return <WrappedComponent formLoading={formLoading} {...props} />
  }
}

export default withState
